<template>
  <div class="node-editor">
    <NodeEditorToolbar
      :toolbar="toolbar"
      :selected="selected"
      @heading-change="onHeadingChange"
      @layout-change="onLayoutChange"
      @toolbar-action="onToolbarAction"
    />
    <div
      class="node-editor__content"
      data-nodetype="node-editor"
      ref="content"
      :id="`node-editor-${node.uuid}`"
    >
      <slot></slot>
    </div>
    <div class="node-editor__options">
      <button class="node-editor__btn cancel" type="button" @click="$emit('editFinish')">
        Done
      </button>
      <!--<button class="node-editor__btn delete" type="button" @click="$emit('delete')">Delete</button>-->
    </div>
  </div>
</template>

<script>
import NodeEditorToolbar from './NodeEditorToolbar.vue';

const DEFAULT_TOOLBAR = ['formatting', 'alignment', 'heading', 'layout'];

export default {
  name: 'NodeEditor',
  inject: ['editBus'],
  components: {
    NodeEditorToolbar,
  },
  props: {
    toolbar: {
      default: () => DEFAULT_TOOLBAR,
      type: Array,
    },
    node: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selected: null, //Range object that contains content
    };
  },
  mounted() {
    this.$refs['content'].addEventListener('click', this.getSelected);
    this.selected = document.createRange();
    this.selected.setStart(this.$refs['content'], 0);
  },
  beforeUnmount() {
    this.$refs['content'].removeEventListener('click', this.getSelected);
  },

  methods: {
    getSelected() {
      let selection = window.getSelection();
      let range = selection.getRangeAt(0);
      this.selected = range;
    },
    onHeadingChange(level) {
      this.editBus.update({ 'meta.headingLevel': level });
    },
    onLayoutChange(layout) {
      this.editBus.update({ layout: `document-node--width-${layout}` });
    },
    onToolbarAction(action) {
      this.$emit('change', action);
    },
  },
};
</script>

<style>
.node-editor {
  margin: 0.25rem auto;
  min-height: 3.6rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.node-editor__content {
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  padding: 2rem 1rem;
}

.node-editor__content [contenteditable='true'] {
  outline: 0;
}

.node-editor__options {
  padding: 1rem;
}

.node-editor__btn {
  cursor: pointer;
  background: 0;
  border: 0;
  font-size: 1rem;
  padding: 0.5rem;
}

.node-editor__btn.save {
  min-width: 10ch;
  text-align: left;
}

.node-editor__btn.cancel {
  color: gray;
}

.node-editor__btn.delete {
  color: darkred;
  margin-left: auto;
  float: right;
}
</style>
